import React, { memo, useCallback } from 'react'

import { Add, Button, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { useLocation, useNavigate } from 'Pods/Shared/ContextBasedRouter'
import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { clearModelSettings } from 'Pods/ThreeDStudio/Store/actions/modelSettings'
import { setIsModelSettingsOpen } from 'Pods/ThreeDStudio/Store/actions/ui'

const icon = <Icon svgComponent={Add} size={iconSize} color="dark" notSpaced />

function NotFoundState({ onNavigate, onClearSearch }) {
  const t = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const handleGenerate = useCallback(() => {
    clearModelSettings()
    if (location?.pathname !== '/ai') {
      navigate('/ai')
    }
    setIsModelSettingsOpen(true)
    onClearSearch()
    onNavigate('new')
  }, [navigate, location, onClearSearch, onNavigate])

  return (
    <div className="not-found-state">
      <p className="not-found-state__text cgt-body-base-semibold">
        {t('sidebar.library.notFound.text')}
      </p>
      <Button
        type="secondary"
        variant="with-icon"
        size="tiny"
        actionType="button"
        icon={icon}
        customClass="not-found-state__button"
        onClick={handleGenerate}
      >
        {t('sidebar.actions.generateNewModel')}
      </Button>
    </div>
  )
}

NotFoundState.propTypes = {
  onNavigate: func.isRequired,
  onClearSearch: func.isRequired,
}

export default memo(NotFoundState)
